// extracted by mini-css-extract-plugin
export default {"helpContainer":"help_helpContainer__HxL-4","helpContent":"help_helpContent__m0Avk","imgContainer":"help_imgContainer__hwB1N","expandContainer":"help_expandContainer__5On9E"};